const Form084TC = {
    stepName: {
        importantNotes: "重要事項",
        supplementary: "補充頁\n(由教師填寫)",
        regrading: "中學教員改編為學位教師",
        certification: "認證",
        detailsOfRegrading: "改編職系詳情",
        approverCertification: "聲明",
        annex: "教職員編制及在職人數表附件",
        formA: "認證",
        schoolOfInformation: "學校管理人員填寫中學教員改編為學位教師表格",
        formB: "基本資料",
        confirmation: "確認",
    },
    label: {
        statement: "我已閱讀、理解並同意上述條款和條件。",
        title: "個人資料收集聲明",
        collectionStatement: "個人資料收集聲明",
        supplementary: "中學教員改編為學位教師─補充頁",
        schoolOfInformation: "基本資料",
        detailsOfRegrading: "改編職系詳情",
        certification: "聲明",
        schoolName: "學校名稱",
        schoolCode: " 學校代碼",
        schoolSession: "授課時間",
        contactPerson: "聯絡人",
        tel: "電話號碼",
        contactAndTelText1: "學校聯絡人",
        contactAndTelText2: "及其電話號碼",
        contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",
        committee: "校董會",
        committeeOption: {
            smc: "校董會",
            imc: "法團校董會",
        },
        mode: "已批准下列署任安排",
        ref: "檔號",
        date: "日期",

        personal: "個人資料",
        Teachertitle: "稱謂",
        titleOp: {
            Mr: "先生",
            Miss: "小姐",
            Mrs: "太太",
            Ms: "女士",
        },

        staffRef: "員工檔號",
        appointment: "聘任資料",
        appointment2:
            "﹝如有需要，請另頁填寫。持有非本地學歷及/或專業訓練，請提交評審結果及/或其他相關資料詳情。﹞",
        college: "學院／大學／院校",
        certificate: "獲頒的證書／文憑／學位",
        dateOfAward: "頒授日期（年）",
        dateOfAward2: "頒授日期（月）",
        dateOfAward3: "頒授日期（日）",
        major: "主修及副修科目",
        school: "學校／學院／大學／院校",
        course: "修讀課程／科目",
        institute: "學校／院校",
        type: "所屬類別",
        rank: "職級",
        dateFrom: "由（日／月／年）",
        dateTo: "至（日／月／年）",
        fullOrPart: "全職或兼任教師",
        fullOrPartOp: {
            fullTime: "全職",
            partTime: "兼任",
        },
        sourceOfFunding: "經費來源",
        signatureOfTeacher: "教師簽署",
        ssdo: "學校所屬的教育局區域教育服務處﹝經辦人：高級學校發展主任 (",
        ssdo2: ") ﹞",
        ssdoLabel: "高級學校發展主任",
        committeeText1: "1. *",
        committeeText2: "已批准下列的改編職系安排﹝檔號",
        committeeText3: "及日期：",
        committeeText4: "﹞",
        committeeText5: "，而有關人員的薪金資料需因此而作出以下的改動：",
        changesInSalaryDetails: "薪金改動詳情",
        englishName: "教師英文姓名",
        chineseName: "教師中文姓名",
        englishName2: "英文姓名",
        chineseName2: "中文姓名",
        hkid: "香港身份證號碼",
        srn: "員工檔號",
        hkid2: "香港身份證號碼",
        srn2: "員工檔號",
        monthlySalaryBeforeRegrading: "薪金(總薪級表薪點)改編前",
        rankBeforeRegrading: "職級(改編前)",
        monthlySalaryUponRegrading: "薪金(總薪級表薪點)改編後",
        rankUponRegrading: "職級(改編後)",
        effectiveDate: "生效日期：",
        incrementalDate: "增薪日期(01/月)",
        nextIncrementDate: "下次增薪日期(01/月/年)",
        salaryBar: "薪金關限(如適用)(總薪級表薪點)",
        maximumSalary: "頂薪點(總薪級表薪點)",
        annex: "2. 在",
        annex2: "附件",
        annex3: "內的教職員編制及在職人數表顯示有空缺為上述教師改編職系。",
        confirm:
            "3. 本人現確認在本表格第1至2段內及「補充頁」所載的資料均正確無誤，本人亦承諾有關改編事宜不會令學位教師數目超逾已核准的學位教師職位編制。本人亦承諾本校會把多付的薪金津貼退還教育局。",
        pointOption: {
            na: "NA",
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46（44B）",
            fortyFive: "45（44A）",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36（33C）",
            thirtyFive: "35（33B）",
            thirtyFour: "34（33A）",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        confirmBtn: "確認",
        supervisorOrSchoolHead: "校監/校長",
        supervisorOrSchoolHeadOption: {
            supervisor: "校監",
            schoolHead: "校長",
        },
        iamStatement: "本人明白需透過「智方便+」帳戶以辧理申請。",
        chooseTheSchool: "選擇學校（中學／特殊學校）",
        chooseTheSchoolOption: {
            secondarySchool: "中學",
            specialSchool: "特殊學校",
        },
        nameDescription: "姓名（如香港身份證所示）",
    },
    monthOption: {
        jan: "0",
        feb: "1",
        mar: "2",
        apr: "3",
        may: "4",
        jun: "5",
        jul: "6",
        aug: "7",
        sep: "8",
        oct: "9",
        nov: "10",
        dec: "11",
    },
    tabel: {
        title1: "學術資格",
        title2: "專業培訓",
        title3: "教學經驗",
        title4: "曾放取的無薪假期﹝ 如有 ﹞",
    },
    note: {
        note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途：",
        note2: "每份表格只適用於一項改編職系安排。",
        note3: "如改編後的薪金是以重新評估的方法",
        note3a: "計算，請填寫「補充頁」。",
        note4: "請在填寫前，詳細閱讀個人資料收集聲明。",
        note5: "請確保教師 知悉本表格及「補充頁」(如適用)所填報的內容，並已閱讀個人資料收集聲明。",

        note6: "請指明學校所屬類別，例如資助、官立、私立、按額津貼、買位、直資.....",
        note7: "如屬兼任教師，請闡述佔全職工作的比例。",
        note8: "請闡述經費來源，例如：薪金津貼、優質教育基金、營辦開支整筆津貼、學校發展津貼、私人款項.....",

        note9: "以重新評估方法計算薪金，即以當時生效的起薪點另加經驗增薪點(如適用)來計算支薪點。",
        note10: "在改編職系的生效日期前須完成所需的程序(包括校董會／法團校董會的批准)。在一般情況下，改編職系的生效日期不具追溯效力。",
        note11: "教育局將會對每份改編職系申請作出編制預先核查。如有關改編職系的教師於委任日已超逾該校的核准教學人員編制，在釐清該改編職系安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",

        note16: "(a) 辦理與聘用有關的事宜；",
        note17: "(b) 處理發放薪金津貼及其他政府資助；",
        note18: "(c) 計算公積金的供款；",
        note19: "(d) 進行核數工作；",
        note20: "(e) 進行研究及統計資料，以便規劃教育服務；",
        note21: "(f) 處理有關教育專業人員發展的事宜；",
        note26: "(g) 執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
        note22: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        note23: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        note24: "根據《個人資料（私隱）條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note25: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
    },
    errorMsg: {
        E0001: "請輸入一個有效的學校名稱",
        E0002: "請輸入一個有效的學校代碼",
        E0003: "請輸入一個有效的職級",
        E0004: "請輸入一個有效的職級",
        E0006: "請輸入一個有效的檔號",
        E0007: "請輸入一個有效的聯絡人",
        E0008: "薪金改編後不應大於頂薪點",
        englishName: "請輸入一個有效的教師英文姓名",
        chineseName: "請輸入一個有效的教師中文姓名",
        numberOnly: "請輸入一個有效的8位數字",
        substantiveRank: "請輸入一個有效的實任職級",
        rankOfActingAppointment: "請輸入一個有效的署任職級",
        refNum: "請輸入一個有效檔號",
        digits: "{{name}}必須為{{len}}位數字",
        characters: "{{name}}必須為{{len}}位字符",
        hkidEmpty: "括號內的值不能為空",
        Note001:
            "注 1.所有晉升教師或代理任命的必要程式都應在生效日期之前完成，包括獲得校董會/校董會的批准。 一般情況下，晉升日期和代理任命日期不具有追溯效力。",
    },
};
export default Form084TC;
